import React, { useEffect, useState } from "react";
import Banner from "../components/home/Banner";
import Partner from "../components/home/partner";
import Metrics from "../components/home/metrics";
import FeatureArticles from "../components/home/FeatureArticles";
import Projects from "../components/home/projects";
import ProjectDetail from "../components/home/projectDetail";
import EventCalendar from "../components/home/event";
import Contact from "../components/home/contact";
import PROJECT_SERVICE from "../api/project";

const Home = () => {
  let [landingProjects, setLandingProjects] = useState({});

  async function getLandingProducts() {
    const res = await PROJECT_SERVICE.landingProjects();
    if (res?.status === 200) {
      setLandingProjects(res?.data);
    }
  }

  useEffect(() => {
    getLandingProducts();
  }, []);

  return (
    <>
      <Banner />
      {/*<Metrics />*/}
      <div className="container mx-auto px-4 py-16">
        {landingProjects && landingProjects?.featuredProject && (
          <ProjectDetail project={landingProjects?.featuredProject} />
        )}
        <Contact />
        {landingProjects && landingProjects?.landingProjects && (
          <Projects projects={landingProjects?.landingProjects} />
        )}
        <Partner />
        {/*<EventCalendar />*/}
        {/*<FeatureArticles />*/}
      </div>
    </>
  );
};

export default Home;
